import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionDummyRoomKeyVisual } from "./key-visual";
import { QuestionDummyRoomName } from "./name";

import type { DummyRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	base: DummyRoomCategoriesAndManagerStore["base"];

	hotelID: string;
	roomID: string;
};

export const QuestionDummyRoomBase = ({ base, hotelID, roomID }: Props) => {
	const ownerID = hotelID;
	const resourceID = roomID;

	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionDummyRoomName />
			<QuestionDummyRoomKeyVisual ownerID={ownerID} resourceID={resourceID} />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionDummyRoomBase.displayName = "QuestionDummyRoomBase";
